import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import ReactMarkdown from 'react-markdown';
import Fuse from "fuse.js";
import axios from 'axios';
import UploadWrapper from './UploadWrapper.js';
import CreateClient from './CreateClient.js';
import CreateOrder from './CreateOrder.js';
import { useAuthContext } from '../contexts/AuthContext.js';
import CreateMeeting from "./CreateMeeting.js";

import { io } from "socket.io-client";
import MessageAttachments from "./MessageAttachments.js";
import AILoadingText from "./AILoadingText.js";
import { useUploadContext } from "../contexts/UploadContext.js";
import { v4 as uuidv4 } from "uuid";
import { api } from "../apiClient.js";
import { useSocket } from "../contexts/SocketContext";
import { linkify } from "../utils/linkify.js";

const MessageForm = ({
  isSidebarVisible, setIsSidebarVisible,
  selectedProjectData, selectedtopic
  // uploadedFiles, setUploadedFiles 
}) => {
  const { AuthData, updateAuthData, user, setUser } = useAuthContext();
  const { socket, connected } = useSocket();
  const [selectedComponent, setSelectedComponent] = useState(null); // 管理顯示的元件
  const [input, setInput] = useState("");
  const [component, setComponent] = useState(null);
  const [azureOpenAIResponse, setAzureOpenAIResponse] = useState([]);
  const [flaskLoading, setFlaskLoading] = useState(null);
  const sentMessageIdsRef = useRef(new Set());
  const textareaRef = useRef(null);

  // ⭐ 自動調整高度
  useLayoutEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto";               // 先重置
    el.style.height = `${el.scrollHeight}px`; // 再撐高 // 內容實際高度
  }, [input]);

  const handleKeyDown = (e) => {
    console.log("keydown event:", e);
    if (e.isComposing || e.keyCode === 229) return;
    // Enter 送出、Shift+Enter 換行
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const options = {
    includeScore: true,
    threshold: 0.4,
  };

  const keywords = {
    "新增客戶": ["新增客戶", "創建客戶", "建立客戶", "Client", "dk4cj4"],
    "新增訂單": ["新增訂單", "創建訂單", "建立訂單", "Order", "2/u420 "],
    "上傳": ["上傳", "檔案", "提交檔案", "傳檔", "Upload", "g;4tj06"],
    "新增會議": ["新增會議", "創建會議", "建立會議", "Meeting", "cjo4u4"],
    // "檔名資料": ["檔案", "文件", "查找檔案", "搜尋檔名"],
  };

  const [messages, setMessages] = useState([]);
  // const socketRef = useRef(null); // 建立 socket 參考

  // useEffect(()=>{
  //   setUploadAttachments([])
  // },[])

  useEffect(() => {
    const token = sessionStorage.getItem("flaskAccessToken");
    // console.log("flaskAccessToken:", sessionStorage.getItem("flaskAccessToken"));

    if (!token) return;

    // 呼叫 Flask API 取得歷史訊息
    fetch(`http://localhost:5000/messages?topic_id=${selectedtopic.topic_id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        console.log("歷史訊息", data);
        setMessages(Array.isArray(data) ? data : []); // 如果有歷史訊息
      });

    // // 建立 WebSocket 連線
    // socketRef.current = io("http://localhost:5000", {
    //   query: { token }
    // });

    // console.log("WebSocket 實例:", socketRef.current);

    // if (!socketRef.current) return;

    const handler = (msg) => {
      console.log("🔥 receive_message:", msg);
      // console.log("msg.topic_id:", msg.topic_id);
      // console.log("selectedtopic.id:", selectedtopic.id);

      if (msg.topic_id !== selectedtopic.topic_id) {
        console.log("❌ 不是目前這個 topic 的");
        return; // 不是目前這個 topic 的，忽略
      }

      // ⭐ 如果 server 回傳的 msg 有 tempId，而且是自己發出的，就忽略
      if (msg.tempId && sentMessageIdsRef.current.has(msg.tempId)) {
        // 我們已經畫過這則訊息了 → 不要重複加入
        console.log("❌ 已經畫過這則訊息");
        return;
      }
      // ⭐ 不然就正常加入 message
      setMessages((prev) => [...prev, msg]);
    };
    socket.on("receive_message", handler);

    // socketRef.current.on("receive_message", (msg) => {
    //   setMessages((prev) => [...prev, msg]);
    // });

    // 清除連線
    // return () => socketRef.current.disconnect();
    return () => {
      socket.off("receive_message", handler);
    };
  }, [socket, connected, selectedtopic]);

  useEffect(() => {
    console.log("MessageForm messages:", messages)
  }, [messages])

  useEffect(() => {
    console.log("目前選取的 Topic:", selectedtopic);
    setUploadAttachments([])
  }, [selectedtopic]);




  // 監聽 component 的變化，自動顯示/隱藏側邊欄
  useEffect(() => {
    if (component != null) {
      setIsSidebarVisible(true); // 顯示側邊欄
    } else {
      setIsSidebarVisible(false); // 隱藏側邊欄
    }
  }, [component]); // 當 input 改變時執行

  useEffect(() => {
    console.log(azureOpenAIResponse);
  }, [azureOpenAIResponse])

  const { uploadAttachments, updateUploadAttachments, setUploadAttachments } = useUploadContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("執行 handleSubmit");
    const trimmed = input.trim();
    if (!trimmed) return alert("請輸入文字！");

    // 先準備好這兩個變數，兩個分支都可以用
    let filesForMessage = [];
    let urls = [];
    // 🧠 共用一個 helper：把上傳結果轉成前端要用的格式
    const buildFilesFromUploadResponse = (uploadResponse) => {
      const data = uploadResponse?.data || [];
      const files = data.map((file, idx) => ({
        id: file.id ?? idx,
        file_name: file.file_name,
        file_url: file.view_url,
        file_type: file.file_type,
        file_size: file.file_size,
      }));
      const urlList = files.map((f) => f.file_url);
      return { files, urlList };
    };

    if (trimmed.startsWith("@ai")) {
      console.log("執行@ai聊天邏輯");
      // 呼叫 Azure OpenAI
      const aiPrompt = trimmed.replace("@ai", "").trim();
      setFlaskLoading(true);
      // console.log(aiPrompt);
      // setAzureOpenAIResponse("");
      // console.log("selectedtopic.id:", selectedtopic.id)

      // 1. 傳遞文字給 AI 解析
      try {
        // 1️⃣ 如果有附件就上傳
        const uploadResponse = await handleUploadAttachments(aiPrompt, "ai");
        const data = uploadResponse?.data || [];
        // 所有附件都掛在同一個 message，所以拿第 1 筆就好
        const first = data[0] || {};
        const message_id = first.id;                // 後端塞的 message_id
        const created_at = first.created_at;        // 後端塞的 created_at（建議後端轉成 iso 字串）

        const { files, urlList } = buildFilesFromUploadResponse(uploadResponse);
        filesForMessage = files;
        urls = urlList;
        setFileUrls(urls);

        // ⭐ 產生 tempId（唯一識別碼）
        const tempId = uuidv4();
        sentMessageIdsRef.current.add(tempId);

        // console.log("143 user.name:",user.name)
        setMessages((prev) => [
          ...prev,
          {
            tempId,
            role: "user",
            from: user.name,
            message: trimmed,
            files: filesForMessage,    // ⭐ 這裡塞附件
            created_at: created_at || new Date().toISOString(),
          },
        ])


        // ⭐ 再送給 server（帶 tempId）
        if (socket) {
          socket.emit("send_message", {
            tempId,
            message_id,              // 有附件就帶，沒有附件就 undefined
            message: trimmed,       // ⭐ 建議用 aiPrompt，比較一致
            order_id: selectedProjectData.order_id,
            topic_id: selectedtopic.topic_id,
            file_urls: urls,
            files: filesForMessage,
            created_at: created_at || new Date().toISOString(),
          });
        }

        // console.log("selectedtopic.id:", selectedtopic.id)
        // const response = await axios.post("http://localhost:5000/api/chat", {
        const response = await api.post("/api/chat", {
          user_id: user.user_id,
          user_input: aiPrompt,
          file_urls: urls,
          is_personal_conversation: false,
          topic_id: selectedtopic.topic_id,
          order_id: selectedProjectData.order_id,
          target_type: "ai",
          mode: "DIRECT_AI",
        });

        // setMessages((prev) => [
        //   ...prev,
        //   {
        //     role: 'assistant',
        //     from: 'AI',
        //     message: response.data.message,
        //     created_at: new Date().toISOString(),
        //   }
        // ])
        // console.log("OpenAI response:", response);

        // // ⭐ 再送給 server（帶 tempId）
        // if (socketRef.current) {
        //   socketRef.current.emit("send_message", {
        //     tempId,
        //     message_id,              // 有附件就帶，沒有附件就 undefined
        //     message: trimmed,       // ⭐ 建議用 aiPrompt，比較一致
        //     order_id: selectedProjectData.order_id,
        //     topic_id: selectedtopic.id,
        //     file_urls: urls,
        //     files: filesForMessage,
        //     created_at: created_at || new Date().toISOString(),
        //   });
        // }


      } catch (error) {
        console.error("Error communicating with the server:", error);
      } finally {
        console.log(flaskLoading);
        setFlaskLoading(false);
        setInput("");
      }
    } else {
      // 執行一般聊天邏輯（例如 WebSocket 廣播）
      console.log("執行一般聊天邏輯");
      if (!socket) return;
      try {
        const uploadResponse = await handleUploadAttachments(trimmed, "");
        const data = uploadResponse?.data || [];
        // 所有附件都掛在同一個 message，所以拿第 1 筆就好
        const first = data[0] || {};
        const message_id = first.id;                // 後端塞的 message_id
        const created_at = first.created_at;        // 後端塞的 created_at（建議後端轉成 iso 字串）

        const { files, urlList } = buildFilesFromUploadResponse(uploadResponse);
        filesForMessage = files;
        urls = urlList;

        // ⭐ 產生 tempId（唯一識別碼）
        const tempId = uuidv4();
        sentMessageIdsRef.current.add(tempId);

        // ⭐ 本地先顯示（立即回饋 UX 比較好）
        // 3️⃣ 本地先把自己的訊息 + 附件畫出來
        setMessages((prev) => [
          ...prev,
          {
            tempId,
            role: "user",
            from: user.name,
            message: trimmed,
            files: filesForMessage,
            created_at: created_at || new Date().toISOString(),
          },
        ]);

        console.log("selectedtopic:", selectedtopic)

        // ⭐ 再送給 server（帶 tempId）
        socket.emit("send_message", {
          tempId,
          message_id: message_id,
          message: trimmed,
          order_id: selectedProjectData.order_id,
          topic_id: selectedtopic.topic_id,
          file_urls: urls,      // 後端可以用來存 DB 或廣播給其他人
          files: filesForMessage, // 如果你想要 server 也拿到完整 metadata
          created_at: created_at || new Date().toISOString(),
        },
          async (ack) => {
            console.log("ack:", ack);
            // ✅ ack 由後端回傳：{ message_id: 123, created_at: "..." }
            const savedMessageId = ack?.message_id || message_id;

            await api.post("/api/chat", {
              user_id: user.user_id,
              user_input: trimmed,
              file_urls: urls,
              is_personal_conversation: false,
              topic_id: selectedtopic.topic_id,
              order_id: selectedProjectData.order_id,
              mode: "CHAT",
              message_id: savedMessageId, // ✅ 一定有
              tempId,
            });
          });

        setInput("");

        // const response = await api.post("/api/chat", {
        //   user_id: user.user_id,
        //   user_input: trimmed,
        //   file_urls: urls,
        //   is_personal_conversation: false,
        //   topic_id: selectedtopic.topic_id,
        //   order_id: selectedProjectData.order_id,
        //   // target_type: "ai",
        //   mode: "CHAT",
        // });

      } catch (error) {
        console.error("Error in websocket send:", error);
      } finally {
        setFlaskLoading(false);
      }
    }
  };

  const handleChange = (e) => {
    const text = e.target.value;
    let matchedComponent = null;

    for (const [key, words] of Object.entries(keywords)) {
      const fuse = new Fuse(words, options);
      const result = fuse.search(text);
      if (result.length > 0) {
        if (key === "新增客戶") matchedComponent = <CreateClient />;
        else if (key === "新增訂單") matchedComponent = <CreateOrder />;
        else if (key === "上傳") matchedComponent = <UploadWrapper />;
        else if (key === "新增會議") matchedComponent = <CreateMeeting />;
        // else if (key === "檔名資料") {
        //   // 假設 fetchFileUrls 返回檔案列表，並更新到某個元件中
        //   matchedComponent = <div>檔名相關搜尋結果</div>;
        // }
        break;
      }
    }

    setComponent(matchedComponent);
    setInput(e.target.value);
  };


  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const [fileUrls, setFileUrls] = useState([]);

  // 上傳文件與數據
  const handleUploadAttachments = async (message, target_type) => {
    console.log("handleUploadAttachments target_type:", target_type)
    // e.preventDefault();

    // 從 uploadData.files 中獲取檔案名稱
    // const title = uploadData.files?.[0] || ""; // 獲取第一個檔案名稱，預設為空字串
    // // 收集所有表單數據
    // const fileData = {
    //   // title: uploadData.fileName[0], // 使用同步的檔案名稱
    //   access: selectedAccess,
    //   client: selectedClient,
    //   project: selectedProject,
    //   fileName: uploadData.fileName,
    //   file: uploadData.file,
    // };
    // console.log(fileData);
    // updateUploadData(fileData);

    // console.log("File Data to Update:", fileData); // 確認即將更新的資料

    if (!uploadAttachments || uploadAttachments.length === 0) {
      return { data: [] }; // 沒檔案就給空陣列，前面不會壞掉
    }
    console.log("uploadAttachments:", uploadAttachments); // 確認即將更新的資料

    const payload = new FormData();
    // 遍歷 uploadData 陣列，將每個檔案和元數據附加到 FormData
    uploadAttachments.forEach((attachment, index) => {
      // 將元數據轉為 JSON 字串
      payload.append(`metadata_${index}`, JSON.stringify({
        // access: data.access,
        // client: data.client,
        // case_no: "case_no",
        // case_name: data.case_name,
        // type: data.type,
        message_type: "topic",
        // id: selectedtopic?.id,
        user_input: message,
        user_id: user?.user_id || 1,
        file_name: attachment.fileName,
        relative_path: attachment.file?.relativePath || attachment.fileName,  // ✅ 新增這行
        file_type: attachment.file?.type,
        file_size: attachment.file?.size,
        order_id: selectedProjectData.order_id,
        topic_id: selectedtopic.topic_id,
        target_type: target_type,
      }));
      console.log('file_type:', attachment.file?.type)
      // 附加檔案
      payload.append(`file_${index}`, attachment.file); // 檔案物件
    });
    // for (let pair of payload.entries()) {
    //   console.log(pair[0], pair[1]); // 驗證 payload
    // }

    try {
      console.log(payload);
      // setUploadStatus("上傳中...");
      // const response = await axios.post("http://127.0.0.1:5000/attachments-upload",
      const response = await api.post("/attachments-upload",
        payload,
        {
          headers: {
            // Authorization: `Bearer ${loginResponse.accessToken}`,
            "Content-Type": "multipart/form-data",
            // timeout: 300000  // 5 分鐘
          },
        }
      );
      console.log(response);
      // setUploadStatus("上傳完成！");

      setUploadAttachments([])  // 如果你有這個 state，記得清掉附件

      return response;
      // // 更新 fileUrls 狀態
      // setFileUrls(response.data); // response.data 是一個包含字典的數組

    } catch (error) {
      console.error("上傳失敗:", error);
      // setUploadStatus("上傳失敗！");
    }


    // if (!file || !formData.title || !formData.description || !formData.keywords) {
    //   setUploadStatus("請填寫所有欄位並選擇文件！");
    //   return;
    // }

    // const payload = new FormData();
    // payload.append("file", file);
    // payload.append("title", formData.title);
    // payload.append("description", formData.description);
    // payload.append("keywords", formData.keywords);

    // try {
    //   setUploadStatus("上傳中...");
    //   const response = await axios.post("http://127.0.0.1:5000/upload", payload, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   });
    //   setUploadStatus(`上傳成功！文件 URL: ${response.data.url}`);
    // } catch (error) {
    //   console.error("上傳失敗:", error);
    //   setUploadStatus("上傳失敗！");
    // }
  };

  const handleFileDrop = (files) => {
    // const newEntries = files.map((file) => ({
    //   fileName: file.name,
    //   file, // 將檔案物件存入
    //   access: "", // 初始為空，submit 時再更新
    //   client: "",
    //   project: "",
    // }));
    // updateUploadData(newEntries); // 將新檔案加入 context
    const newEntries = files.map((file) => ({
      fileName: file.name,
      file, // 儲存檔案物件
      // ...commonData, // 即時同步表單資料
    }));
    updateUploadAttachments(newEntries); // 更新 Context，覆蓋舊檔案
    console.log(uploadAttachments);
  };



  // {messages.map((m, i) => (
  //   <>
  //     {/* <hr /> */}
  //     <br></br>
  //     <div key={i}
  //     >
  //       <div>
  //         <b>{m.from}</b>
  //         <span className="message-time">{formatTime(m.created_at)}</span>
  //       </div>
  //       {
  //         m.from !== 'AI'
  //           ? <div>{linkify(m.message)}</div>
  //           : <ReactMarkdown>{m.message}</ReactMarkdown>
  //       }
  //       <MessageAttachments files={m.files} />
  //     </div>
  //   </>
  // ))}




  return (
    <div style={{ height: "100%", }}>
      <div><strong>Chat</strong></div>
      <div className='chat-log-topic'>
        {messages.map((m, i) => (
          <React.Fragment key={i}>
            <br />
            <div>
              <div>
                <b>{m.from}</b>
                <span className="message-time">{formatTime(m.created_at)}</span>
              </div>

              {/* ✅ Gatekeeper 卡片 */}
              {m.type === "ai_card" ? (
                <div className="ai-card">
                  <div className="ai-card-title">{m.title || "AI 建議"}</div>
                  <div className="ai-card-body">
                    {/* message 可能是純文字或 markdown，你可以先用 markdown */}
                    <ReactMarkdown>{m.message}</ReactMarkdown>
                  </div>

                  {/* 可選：按鈕 */}
                  {Array.isArray(m.actions) && m.actions.length > 0 && (
                    <div className="ai-card-actions">
                      {m.actions.map((a, idx) => (
                        <button
                          key={idx}
                          type="button"
                          onClick={() => {
                            // 最簡：把建議 prompt 塞回 input，或直接 @ai
                            if (a.type === "prefill") setInput(a.text || "");
                            if (a.type === "prefill_ai") setInput(`@ai ${a.text || ""}`);
                          }}
                        >
                          {a.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ) : m.from !== "AI" ? (
                <div style={{ whiteSpace: "pre-line" }}>{linkify(m.message)}</div>
              ) : (
                <ReactMarkdown>{m.message}</ReactMarkdown>
              )}

              <MessageAttachments files={m.files} />
            </div>
          </React.Fragment>
        ))}


        {/* <br /> */}
        {/* {azureOpenAIResponse &&
          azureOpenAIResponse.map((msg, index) => (
            <div
              key={index}
            // className={`message-bubble ${msg.role === "user" ? "question" : "response"}`}
            >
              <b>{msg.from}</b>
              <span>{formatTime(msg.created_at)}</span>
              <ReactMarkdown>{msg.content}</ReactMarkdown>
              <MessageAttachments files={msg.files} />
            </div>
          )
          )} */}


        {flaskLoading ? <AILoadingText /> : ""}
        {/* 根據不同的回應顯示不同的內容 */}
      </div>

      <form className={`create-form ${isSidebarVisible ? 'sidebar-open' : ''}`}
        onSubmit={handleSubmit}>
        <div className="message-area">
          {/* <input
        type="text"
        value={content}
        onChange={(e) => { setContent(e.target.value) }}
        placeholder="請輸入訊息"
      /> */}
          <div className="message-attachments">
            {uploadAttachments &&
              uploadAttachments.map((uploadAttachment) => {
                return (
                  <div className="message-attachment">
                    {uploadAttachment.fileName}
                  </div>
                )
              })
            }
          </div>
          <div className="message-row">
            <input
              type="file"
              multiple
              // webkitdirectory="true"
              // directory="true"
              onChange={(e) => handleFileDrop(Array.from(e.target.files))}
              style={{ display: "none" }}
              id="fileInput"
            />
            <label
              htmlFor="fileInput"
              className="composer-btn"
            >
              ➕
              {/* 選擇檔案
              <img src='./arrow04.png' style={{
                width: "20%",
              }}></img> */}
            </label>
            <textarea
              ref={textareaRef}
              type="text"
              value={input}
              rows={1}
              // onChange={(e) => setInput(e.target.value)}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              placeholder="Enter your message..."
            // className="chat-textarea"
            />
            <button type="submit">
              <img className="sent-message" src="./sent.png" alt="送出" />
            </button>
          </div>
        </div>
        <div className="toggle-area">
          {/* 固定在畫面右邊的按鈕 */}
          <button
            type="button" className="toggle-button" onClick={toggleSidebar}>
            {isSidebarVisible ? ">>" : "<<"}
          </button>
        </div>

      </form>

      {/* 可顯示/隱藏的右側區塊 */}
      <div className={`sidebar ${isSidebarVisible ? "visible" : "hidden"}`}>
        {/* {renderComponent()} */}
        {component}
      </div>

      <div style={{ marginTop: "20px" }}>{selectedComponent}</div>
    </div>
  );
}


function formatTime(isoString) {
  // MySQL 裡的時間（通常是 UTC 或 server 時區）
  // 2025-11-21T08:51:30 沒有時區資訊的 ISO 字串，new Date() 會把它當 本地時間 8:51 來解析
  console.log("isoString:", isoString)
  if (!isoString) return "";

  // 如果字串沒有 Z 或時區資訊，就補一個 Z，當成 UTC
  const hasTimezone = /Z$|[+-]\d\d:\d\d$/.test(isoString);
  const normalized = hasTimezone ? isoString : isoString + "Z";

  return new Date(normalized).toLocaleString("zh-TW", {
    // year: "numeric",
    // month: "2-digit",
    // day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    // second: "2-digit",
    hour12: true,
  });

}


export default MessageForm;
